// extracted by mini-css-extract-plugin
export default {"section":"WelcomeBanner_section__r8rIM","title":"WelcomeBanner_title__hq3U-","appEntry":"WelcomeBanner_appEntry__-O6Ts","appGrid":"WelcomeBanner_appGrid__Q6GRy"};